import { render, staticRenderFns } from "./SupplierReceivable3.vue?vue&type=template&id=36c800f6&scoped=true&"
import script from "./SupplierReceivable3.vue?vue&type=script&lang=js&"
export * from "./SupplierReceivable3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c800f6",
  null
  
)

export default component.exports